<script>
    import { fly } from "svelte/transition";
    import { createEventDispatcher } from "svelte";
    import { portal } from "svelte-portal";
    import KeyButton from "./KeyButton.svelte";
    import Backspace from "../icons/backspace.svelte";
    export let show = false;
    const clsPrefix = "idpad";
    let items = [1, 2, 3, 4, 5, 6, 7, 8, 9, 0, "X"];
    export let value = "";
    const dispatch = createEventDispatcher();
    const select = (num) => () => (value += num);
    const del = () => (value = value.slice(0, value.length - 1));
    const submit = () => dispatch("submit");
</script>

{#if show}
    <div class={clsPrefix} transition:fly={{ y: 200 }} use:portal={"body"}>
        <div class={`${clsPrefix}-inner`}>
            {#each items as item}
                <KeyButton
                    type="button"
                    class={`${clsPrefix}-btn`}
                    on:click={select(item)}>{item}</KeyButton
                >
            {/each}
            <KeyButton
                disabled={!value}
                class={`${clsPrefix}-btn ${clsPrefix}-btn-del`}
                on:click={del}
            >
                <Backspace color="#000" size={22} />
            </KeyButton>
        </div>
        <div class={`${clsPrefix}-actions`}>
            <!-- <KeyButton
                disabled={!value}
                class={`${clsPrefix}-btn ${clsPrefix}-btn-del`}
                on:click={del}
            >
                <Backspace color="#000" size={22} />
            </KeyButton> -->
            {#if items && items.length > 0}
                <KeyButton
                    disabled={!value}
                    class={`${clsPrefix}-btn ${clsPrefix}-btn-ok`}
                    on:click={submit}>完成</KeyButton
                >
            {/if}
        </div>
    </div>
{/if}

<style lang="less">
    @import "./idpad.less";
</style>
